import homePayload from "./HomePayload";
import callPostApi from "../../../requests/PostRequests";
import * as Constants from '../../../requests/URLConstants';
import moment from 'moment';
import * as SalesForceConfig from '../../Dashboards/SalesForceConfig';

export async function getSalesForceTrend(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity) {
    if (timeFilterSelections && workspace && (dashboardFilterSelectionsAutomation || dashboardFilterSelectionsSAP || dashboardFilterSelectionsSalesforce)) {
        let formattedData = {};
        let bodyJSON = homePayload(timeFilterSelections, dashboardFilterSelectionsAutomation, dashboardFilterSelectionsSAP, dashboardFilterSelectionsSalesforce, workspace, entity);

        return callPostApi(Constants.GETSALESFORCETRENDGRAPH, {
            'Content-Type': 'application/json'
        }, bodyJSON)
            .then(resp => {
                formattedData = prepareTrendData(resp, entity);
                return { lineChartData: formattedData ? formattedData.graphData : [], summaryData: formattedData ? formattedData.summaryData : [], barChartData: formattedData ? formattedData.barChartData : [], loader: false };
            }).catch((error) => {
                return { data: null, loader: false };
            });
    }
}

const prepareTrendData = (response, entity) => {
    let graphData = []; let barChartObj = {}; let barChartData = [];
    let summaryData = { total: 0, successful: 0, failures: 0, recurringFailures: 0, longRunningSessions: 0 };
    let graphObj = {};
    if (response.body) {
        let buckets = response.body.aggregations ? response.body.aggregations.events.buckets : {};
        if (Object.keys(buckets).length > 0) {
            if (entity === SalesForceConfig.AbandonedProcess) {
                for (var key of Object.keys(buckets)) {
                    if (key === 'total') {
                        let statusBucket = buckets[key].trend.buckets;
                        for (let i = 0; i < statusBucket.length; i++) {
                            graphObj = {
                                "group": key,
                                "date": moment(statusBucket[i].key_as_string).format('YYYY-MM-DD'),
                                "value": statusBucket[i].count.value
                            }
                            graphData.push(graphObj)
                        }
                        summaryData.total = buckets.total.count.value ? buckets.total.count.value : 0;
                    }
                }
            }
            else {
                for (var key of Object.keys(buckets)) {
                    let statusBucket = buckets[key].trend.buckets;
                    for (let i = 0; i < statusBucket.length; i++) {
                        graphObj = {
                            "group": key,
                            "date": moment(statusBucket[i].key_as_string).format('YYYY-MM-DD'),
                            "value": statusBucket[i].count.value
                        }
                        graphData.push(graphObj)
                    }
                    summaryData.total = buckets.total.count.value ? buckets.total.count.value : 0;
                    summaryData.successful = buckets.successful.count.value ? buckets.successful.count.value : 0;
                    summaryData.failures = buckets.failure.count.value ? buckets.failure.count.value : 0;
                }
            }

            let errorBuckets = response.body.aggregations.top_errors.errors.buckets;
            for (let j = 0; j < errorBuckets.length; j++) {
                barChartObj = {
                    group: errorBuckets[j].key,
                    key: errorBuckets[j].key,
                    value: errorBuckets[j].count.value
                };
                barChartData.push(barChartObj);
            }

            if (response.body.aggregations && response.body.aggregations.alerts) {
                let summaryBucket = response.body.aggregations.alerts.buckets;
                summaryData.recurringFailures = summaryBucket.recurring.count.value ? summaryBucket.recurring.count.value : 0;
                summaryData.longRunningSessions = summaryBucket.longRunning.count.value ? summaryBucket.longRunning.count.value : 0;
            }
        }
        graphData.sort((a, b) => { return new Date(a.date) - new Date(b.date) });
    }
    return { graphData, summaryData, barChartData };
};
